var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"validator","appear":"","mode":"out-in"}},[(_vm.ValidError)?_c('p',{staticClass:"error",class:{ 'type-all': _vm.typeAll }},[_vm._v(" "+_vm._s(_vm.$t(_vm.ValidError))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }